
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anti-pirate/check",
      function () {
        return require("private-next-pages/anti-pirate/check.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anti-pirate/check"])
      });
    }
  